import { useRoute, useRouter } from "vue-router";
import type { LocationQueryValue } from "vue-router";

/**
 * Composable providing navigation helpers.
 */
export function useNavigation() {
  const route = useRoute();
  const router = useRouter();

  /**
   * Navigate back in browser history.
   */
  const navigateBack = (): void => {
    router.go(-1);
  };

  /**
   * Navigate to a given path or named route.
   * @param path Path or route name to navigate to.
   */
  const navigateTo = (path: string): void => {
    router.push(path);
  };

  /**
   * Get the 'id' route parameter as string.
   */
  const getItemId = (): string | undefined => {
    return route.params.id?.toString();
  };

  /**
   * Get a raw query‑string parameter.
   * @param key Query parameter name.
   */
  const getQueryParam = (
    key: string
  ): LocationQueryValue | LocationQueryValue[] | undefined => {
    return route.query[key];
  };

  /**
   * Get a numeric query parameter.
   * @param key Query parameter name.
   * @returns Parsed number or null if missing/not a number.
   */
  const getNumberParam = (key: string): number | undefined => {
    const val = getQueryParam(key);
    if (Array.isArray(val)) {
      return Number(val[0]);
    }
    return Number(val);
  };

  return {
    navigateBack,
    navigateTo,
    getItemId,
    getQueryParam,
    getNumberParam,
  };
}
